import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Card, Footer, Header, Hero, Section } from "../components";
import { db } from "../firebase";
import Archive from "../images/Large_Bottom_Link_Archive.svg";

class Home extends Component {
  state = {
    loading: true,
    costumes: null
  };

  componentDidMount() {
    this.getData();
  }

  getData() {
    this.getCostumes();
    this.getPumpkins();
    this.getPets();
  }

  async getCostumes() {
    const snapshot = await db.collection("person").orderBy("name", "asc").get();
    const costumes = {};
    snapshot.forEach((item) => (costumes[item.id] = item.data()));
    this.setState({ costumes });
  }

  async getPumpkins() {
    const snapshot = await db.collection("pumpkin").orderBy("name", "asc").get();
    const pumpkins = {};
    snapshot.forEach((item) => (pumpkins[item.id] = item.data()));
    this.setState({ pumpkins });
  }

  async getPets() {
    const snapshot = await db.collection("pet").orderBy("name", "asc").get();
    const pets = {};
    snapshot.forEach((item) => (pets[item.id] = item.data()));
    this.setState({ pets });
  }

  onSubmitVote = async (type, ids = []) => {
    // console.log('vote for these', type, ids);
    // const documents = await Promise.all(ids.map( id => {
    //   return db.collection(type).doc(id).get();
    // }));
    // console.log(documents);
    // const responses = await Promise.all(documents.map( doc => {
    //   return db.collection("vote").add({ document: doc.ref })
    // }));
    // console.log('added!', responses);
    try {
      this.setState({ [`${type}Complete`]: true });
      await Promise.all(
        ids.map((id) => {
          return db.collection("vote").add({ document: id });
        })
      );
    } catch (err) {
      console.log("error creating responess", err);
      return this.setState({ [`${type}Complete`]: false });
    }
  };

  render() {
    const {
      costumes,
      pumpkins,
      pets,
      personComplete,
      pumpkinComplete,
      petComplete
    } = this.state;
    return (
      <div className="Home bg-hugepurple text-white">
        <div className="container">
          <Header />
          <Hero />
          <CostumeSection
            data={costumes}
            complete={personComplete}
            onSubmit={(...args) => this.onSubmitVote("person", ...args)}
          />
          <CarvingSection
            data={pumpkins}
            complete={pumpkinComplete}
            onSubmit={(...args) => this.onSubmitVote("pumpkin", ...args)}
          />
          <PetSection
            data={pets}
            complete={petComplete}
            onSubmit={(...args) => this.onSubmitVote("pet", ...args)}
          />
        </div>
        <Footer label="Check out the pre-COVID best.">
          <Link to="/archive">
            <img
              src={Archive}
              alt="Archive"
              className="p-8 transition-colors duration-200 hover:bg-hugeorange"
            />
          </Link>
        </Footer>
      </div>
    );
  }
}

function CostumeSection({ data, loading, onSubmit, complete }) {
  const ids = Object.keys(data || {});
  return (
    <Section
      className="bg-hugepurple text-white"
      buttonClassName="button--light"
      sectionNumber="01"
      sectionName="Costume"
      sectionHeading={
        <span>
          Vote for your
          <br />5 favorites.
        </span>
      }
      defaultSelected={[]}
      data={data}
      loading={loading}
      selectMax={5}
      onSubmit={onSubmit}
      complete={complete}
      submitMessage="Ooooo, now that’s some eye candy."
    >
      {ids.map((id) => {
        const { photo, name, costume } = data[id];
        return (
          <Card
            key={id}
            id={id}
            photo={photo}
            title={name}
            description={costume}
          />
        );
      })}
    </Section>
  );
}

function CarvingSection({ data, loading, complete, onSubmit }) {
  const ids = Object.keys(data || {});
  return (
    <Section
      className="bg-hugepurple text-white"
      buttonClassName="button--light"
      sectionNumber="02"
      sectionName="Pumpkin"
      sectionHeading={
        <span>
          Choose a
          <br />
          carving.
        </span>
      }
      defaultSelected={[]}
      data={data}
      loading={loading}
      onSubmit={onSubmit}
      complete={complete}
      submitMessage="Hell of a choice, friend."
    >
      {ids.map((id) => {
        const { photo, name, theme } = data[id];
        return (
          <Card
            key={id}
            id={id}
            photo={photo}
            title={name}
            description={theme}
          />
        );
      })}
    </Section>
  );
}

function PetSection({ data, loading, complete, onSubmit }) {
  const ids = Object.keys(data || {});
  return (
    <Section
      className="bg-hugepurple text-white"
      buttonClassName="button--light"
      sectionNumber="03"
      sectionName="Pet"
      sectionHeading={
        <span>
          Pick your
          <br />
          partner.
        </span>
      }
      defaultSelected={[]}
      data={data}
      loading={loading}
      onSubmit={onSubmit}
      complete={complete}
      submitMessage="Excellent selection."
    >
      {ids.map((id) => {
        const { photo, name, costume } = data[id];
        return (
          <Card
            key={id}
            id={id}
            photo={photo}
            title={name}
            description={costume}
          />
        );
      })}
    </Section>
  );
}

export default Home;
